import { render } from "./CardIcon.vue?vue&type=template&id=342d5d71"
import script from "./CardIcon.vue?vue&type=script&lang=ts"
export * from "./CardIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script